import Spinner from "../../../Components/spinner";
import { ActionButton, checkImage, ToggleSwitch } from "../../../Components/TableHelper";
import { formatDate } from "../../../utils/constant";

const ProductTableView = ({
  data,
  loading,
  Tableheader,
  handleStatusToggle,
  handleEditClick,
  handleDelete,
}) => {
  return (
    <div className="table-responsive">
      <table className=" custom-table table table-striped" id="slidertable">
        <thead>
          <tr>
            {Tableheader.map((item, index) => (
              <th className="font-weight-bold " key={index}>
                {item}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="12" className="text-center">
                <Spinner />
              </td>
            </tr>
          ) : data?.length > 0 ? (
            data.map((item, index) => (
              <tr key={item._id || index}>
                <td>{item.sortOrder}</td>
                <td>{checkImage(item?.thumbnailImage?.[0])}</td>
                <td>{item?.productTitle}</td>
                <td>{item?.productSKU}</td>
                <td>
                  {[
                    item?.categoryId?.categoryName,
                    item?.qualityId?.qualityName,
                    item?.traceabilityId?.traceabilityName,
                  ]
                    .filter((val) => val && val !== "null")
                    .join(", ")}
                </td>
                <td>
                  <ToggleSwitch
                    data={item}
                    name="isActive"
                    checked={item.isActive}
                    handleStatusToggle={handleStatusToggle}
                    module={"Products"}
                  />
                </td>
                <td>{formatDate(item.updatedAt)}</td>
                <td>
                  <ActionButton
                    data={item}
                    handleEditClick={handleEditClick}
                    handleDelete={handleDelete}
                    module={"Products"}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="12" className="text-center">
                <h5>No data found.</h5>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ProductTableView;